import { createSlice } from '@reduxjs/toolkit'

export const countryListSlice = createSlice({
  name: 'countrylist',
  initialState: {
    value: []
  },
  reducers: {
    setCountryList: (state,action) => {
      state.value = action.payload
    }
   
  }
})

export const { setCountryList } = countryListSlice.actions

export default countryListSlice.reducer